import React, { useState, useEffect } from 'react';
import { TimePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';

const TimePickerRSuite = ({ formik, name, label }) => {
  const [value, setValue] = useState(null);

  // Sync Formik value (HH:mm) to RSuite Date object
  useEffect(() => {
    const val = formik.values[name]; // e.g., "14:30"
    if (val) {
      const [hours, minutes] = val.split(":").map(Number);
      const date = new Date();
      date.setHours(hours);
      date.setMinutes(minutes);
      date.setSeconds(0);
      setValue(date);
    } else {
      setValue(null);
    }
  }, [formik.values[name]]);

  // Convert RSuite Date back to HH:mm for Formik
  const handleChange = (newValue) => {
    if (newValue) {
      const hours = newValue.getHours().toString().padStart(2, "0");
      const minutes = newValue.getMinutes().toString().padStart(2, "0");
      formik.setFieldValue(name, `${hours}:${minutes}`); // store as 24-hour
    } else {
      formik.setFieldValue(name, '');
    }
    setValue(newValue);
  };

  return (
    <div style={{ marginBottom: 10 }} >
      <TimePicker
        value={value}
        onChange={handleChange}
        placeholder="Select time"
        format="hh:mm aa"   // AM/PM display
        showMeridiem        // ensure AM/PM toggle shows
        ranges={[]}         // no seconds
        style={{ height: '32px', fontSize: '14px'}} // smaller overall
        menuStyle={{ zIndex: 2000 }} // ensures dropdown is above modal

      />
    </div>
  );
};

export default TimePickerRSuite;
